var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h1',{staticClass:"tracking-tight text-brand",class:_vm.sizes},[(_vm.title)?_c('span',{staticClass:"bg-clip-text text-transparent bg-gradient-to-r",class:_vm.colours,domProps:{"innerHTML":_vm._s(_vm.title)}}):_c('span',{staticClass:"bg-clip-text text-transparent bg-gradient-to-r",class:_vm.colours},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }